class ProgramComparisonAccordion extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLElement[]} */
    this.cards = [];
  }

  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-accordion-card]'));
    if (!this.cards.length) return;

    this.cards.forEach((card) => {
      const panel = /** @type {HTMLElement | null} */ (card.querySelector('[data-accordion-panel]'));
      if (!panel) return;

      panel.style.overflow = 'hidden';
      panel.style.maxHeight = '0px';
      panel.style.opacity = '0';
      panel.style.transition = 'max-height 340ms ease, opacity 260ms ease';
      panel.classList.add('hidden');
    });

    this.cards.forEach((card) => {
      const trigger = card.querySelector('[data-accordion-trigger]');

      const toggleCard = () => {
        const isOpen = card.getAttribute('data-open') === 'true';
        if (isOpen) {
          this.closeCard(card);
          return;
        }

        this.cards.forEach((item) => {
          if (item !== card) {
            this.closeCard(item);
          }
        });
        this.openCard(card);
      };

      card.addEventListener('click', (event) => {
        const target = /** @type {HTMLElement | null} */ (event.target instanceof HTMLElement ? event.target : null);
        if (target && target.closest('a')) {
          return;
        }
        toggleCard();
      });

      if (trigger) {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          toggleCard();
        });
      }
    });

    const initialOpen = Number(this.dataset.initialOpen || 0);
    const initialCard = this.cards.find((card) => Number(card.dataset.index) === initialOpen);

    this.cards.forEach((card) => this.closeCard(card));
    if (initialCard) {
      this.openCard(initialCard);
    }
  }

  /**
   * @param {HTMLElement} card
   */
  openCard(card) {
    const trigger = /** @type {HTMLElement | null} */ (card.querySelector('[data-accordion-trigger]'));
    const panel = /** @type {HTMLElement | null} */ (card.querySelector('[data-accordion-panel]'));
    const icon = /** @type {HTMLElement | null} */ (card.querySelector('[data-accordion-icon]'));
    const mobileImage = /** @type {HTMLElement | null} */ (card.querySelector('[data-mobile-image]'));

    if (panel) {
      panel.classList.remove('hidden');
      panel.style.maxHeight = '0px';
      panel.style.opacity = '0';

      requestAnimationFrame(() => {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.style.opacity = '1';
      });

      panel.addEventListener(
        'transitionend',
        () => {
          if (card.getAttribute('data-open') === 'true') {
            panel.style.maxHeight = 'none';
          }
        },
        { once: true }
      );

      panel.classList.remove('hidden');
    }
    if (icon) {
      icon.classList.add('rotate-180');
    }
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    card.classList.remove('bg-transparent');
    card.classList.add('bg-white');
    if (mobileImage) {
      mobileImage.classList.remove('h-[100px]');
      mobileImage.classList.add('h-[230px]');
    }
    card.setAttribute('data-open', 'true');
  }

  /**
   * @param {HTMLElement} card
   */
  closeCard(card) {
    const trigger = /** @type {HTMLElement | null} */ (card.querySelector('[data-accordion-trigger]'));
    const panel = /** @type {HTMLElement | null} */ (card.querySelector('[data-accordion-panel]'));
    const icon = /** @type {HTMLElement | null} */ (card.querySelector('[data-accordion-icon]'));
    const mobileImage = /** @type {HTMLElement | null} */ (card.querySelector('[data-mobile-image]'));

    if (panel) {
      panel.style.maxHeight = panel.scrollHeight > 0 ? `${panel.scrollHeight}px` : '0px';
      panel.style.opacity = '1';

      requestAnimationFrame(() => {
        panel.style.maxHeight = '0px';
        panel.style.opacity = '0';
      });

      panel.addEventListener(
        'transitionend',
        () => {
          if (card.getAttribute('data-open') !== 'true') {
            panel.classList.add('hidden');
          }
        },
        { once: true }
      );
    }
    if (icon) {
      icon.classList.remove('rotate-180');
    }
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    card.classList.remove('bg-white');
    card.classList.add('bg-transparent');
    if (mobileImage) {
      mobileImage.classList.remove('h-[230px]');
      mobileImage.classList.add('h-[100px]');
    }
    card.setAttribute('data-open', 'false');
  }
}

if (!customElements.get('program-comparison-accordion')) {
  customElements.define('program-comparison-accordion', ProgramComparisonAccordion);
}
